import Vue from 'vue'
import Router from 'vue-router'
import Test from '../views/test.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // 或 'hash'
  routes: [
    {
      path: '/test',
      name: 'Test',
      component: Test
    },{
        path: '/login',
        name: 'Login',
        component: () => import('../views/login.vue')
    },{
        path:'/index',
        name:'Index',
        component: () => import('../views/index.vue')
    },{
        path:'/index1',
        name:'Index1',
        component: () => import('../views/index1.vue')
    },
     {
        path: '/',
        // component: () => import('@/views/dashboard/index.vue'),
        component: () => import('../views/login.vue'),
        meta: { title: '首页' }
      },
      {
        path: '/user',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: '/role',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理' }
      },
      // ...其他路由配置
  ]
})